import i18n, { t } from 'i18next';

export const tGender = (name: string): string => {
  const key = 'gender_' + name.replace(/\W/g, '');
  const result = t(key);
  return result !== key ? result : name;
};

export interface GenderOption {
  value: string;
  label_en: string;
  label_ua: string;
  label_de: string;
}

/** Подпись пола из static_gender на текущем языке интерфейса */
export const genderLabel = (g: GenderOption): string => {
  const lang = i18n.language;
  if (lang === 'uk' || lang === 'ua') return g.label_ua;
  if (lang === 'de') return g.label_de;
  return g.label_en;
};

export const tEthnicity = (id: number): string => {
  const key = 'ethnicity_' + id;
  const result = t(key);
  return result !== key ? result : String(id);
};
